namespace Nobox { 
    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class DiscountFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            // var text = Q.htmlEncode(ctx.value);
            var $this = this
            //console.log(ctx.item);
            if (ctx.value == null) ctx.value = 0;
            if (text == " " || null) { }
            var text = Q.htmlEncode(ctx.value + "%");

            return text;

        }

        @Serenity.Decorators.option()
        public contractAmount: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.contractAmount)
                column.referencedFields.push(this.contractAmount);
        }
    }
}
